import { FilesFormat, ReportType } from '../enums';
import { ReportField } from '../enums/report-type.enum';
import { ReducedFundData } from './fund.model';
import { SelectData } from './select-input.model';
import { ApplicationUser } from './user.model';

export interface ReportDialogData {
  title: string;
  type: ReportType;
}

export interface ReportGeneration {
  date: string;
  fundId: string;
}

export interface ReportBatchRequest {
  dataSolicitacao: string;
  fundo: ReducedFundData;
  relatorios: string;
  filtros: ReportFilter[];
  formatoArquivo: FilesFormat;
  usuario: ApplicationUser;
}

export interface ReportFilter {
  nomeParametro: ReportField;
  valor: unknown;
}

export interface FileGenerationFilter {
  idFundo: number;
  usuario: number;
  data: string;
  relatorio: string;
  dataFim: string;
  cedenteSacado?: string;
}

export interface ReportFilterDialog {
  data: {
    idRelatorio: number;
    cnpjFundo: string;
    nomeFundo: string;
    data: Date;
    filtros: [
      {
        chave: string;
        valor: string;
      }
    ];
  };
}

export interface ReportRegister {
  idFundo: SelectData;
  rolesSelecionados: {
    AVALISTAS: boolean;
    CONTAS: boolean;
    CONTATOS: boolean;
    ENTIDADES_LIGADAS: boolean;
    REPRESENTANTES: boolean;
  };
}

export interface ReportDraweeRegister {
  idFundo: number;
  comRepresentante: boolean;
}

export interface FundsReports {
  fundo: SelectData,
  carteira: SelectData,
  data: Date,
  idCarteiraBritech: number,
  tipoArquivo: string
}

export interface DownloadCarteira {
  idFundoBritech: number,
  data: string,
  formatoArquivo: string, 
  cnpjFundo: string
}